module.exports = __webpack_public_path__ + "static/media/WebsiteVisualBuild.42d6609c.png";